import { selectIsAuth, selectProfile } from '@store/profile.reducer'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

export default function useDefaultAuthRedirect() {
  const profile = useSelector(selectProfile)
  const isAuth = useSelector(selectIsAuth)

  const setCustomStudentLoginHomePageStore = useSelector(
    (store: any) => store.settings.isCustomStudentLoginHomePage,
  )

  const studentLoginHomePageStore = useSelector(
    (store: any) => store.settings.studentLoginHomePage,
  )

  const handleLoginDestination = () => {
    if (
      setCustomStudentLoginHomePageStore === '1' &&
      profile?.role === 'children'
    ) {
      window.location.replace(studentLoginHomePageStore ?? '/')
      return
    }
  }

  useEffect(() => {
    if (isAuth) {
      handleLoginDestination()
    }
  }, [isAuth])
}
